/* global toastr, recommenderSessionLimit -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import '../../plugins/dl-menu/js/jquery.dlmenu';
import '@common/bootstrap';
import '@common/mobile.menu';
import NavBar from '@components/nav-bar';
import JobList from '@components/job-recommender/job-list';

/**
 * @typedef NextAnonRecResponse
 * @type {object}
 * @property {string|null} nextCursor
 * @property {boolean} hasMorePages
 * @property {string[]} jobs
 */
$(() => {
    const isAnonUser = $('#anonymous-user-recommender').length > 0;
    const $recommender = $('.job-recommender-job-list');
    NavBar.init($);

    if ($recommender.length) {
        const jobList = new JobList({
            source: 'recommender-job-detail',
            recommenderType: 'stacked',
            showDetailsOnActivation: true,
            sessionLimit: recommenderSessionLimit,
        });

        jobList.initFromDOM();
    }

    if (isAnonUser) {
        const $recommendedJobs = $('.recommended-job');

        if ($recommendedJobs.length) {
            const firstRec = $recommendedJobs.get(0);
            firstRec.click();
        }
    }

    $(document).on('job-recommender:apply-success', function(evt) {
        toastr.success(`Your ${evt.detail.numJobs} applications have been submitted successfully.`);
    });
});
